export const getDemoMobileButton = () => {
    document.addEventListener('click', (e) => {
        if(e.target.matches('.mobile-book-demo--button') || e.target.matches('.mobile-book-demo--button *')) {
            e.preventDefault();
            document.querySelector('.get-demo-popup-button').click();
            console.log('clicked')
        }
    });
};